var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardIconBloc',{attrs:{"icon":"check-circle-fill","backColor":"rgb(227,252,239)","frontColor":"rgb(0,135,90)"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }